import produce from 'immer';

export const Types = {
  POST_DATA_BENEFICIARIES_NESTLE_REQUEST:
    '@beneficiario/POST_DATA_BENEFICIARIES_NESTLE_REQUEST',
  POST_DATA_BENEFICIARIES_NESTLE_SUCCESS:
    '@beneficiario/POST_DATA_BENEFICIARIES_NESTLE_SUCCESS',
  POST_DATA_BENEFICIARIES_NESTLE_ERROR:
    '@beneficiario/POST_DATA_BENEFICIARIES_NESTLE_ERROR',
  GET_DOCUMENTOS_STATUS_REQUEST: '@beneficiario/GET_DOCUMENTOS_STATUS_REQUEST',
  GET_DOCUMENTOS_STATUS_SUCCESS: '@beneficiario/GET_DOCUMENTOS_STATUS_SUCCESS',
  GET_DOCUMENTOS_STATUS_ERROR: '@beneficiario/GET_DOCUMENTOS_STATUS_ERROR',
  GET_DOCUMENTO_DETALHE_REQUEST: '@beneficiario/GET_DOCUMENTO_DETALHE_REQUEST',
  GET_DOCUMENTO_DETALHE_SUCCESS: '@beneficiario/GET_DOCUMENTO_DETALHE_SUCCESS',
  GET_DOCUMENTO_DETALHE_ERROR: '@beneficiario/GET_DOCUMENTO_DETALHE_ERROR',
  GET_DOCUMENTO_DETALHE_RENEW: '@beneficiario/GET_DOCUMENTO_DETALHE_RENEW',
  PATCH_DOCUMENTO_CONFERENCIA_REQUEST:
    '@beneficiario/PATCH_DOCUMENTO_CONFERENCIA_REQUEST',
  PATCH_DOCUMENTO_CONFERENCIA_SUCCESS:
    '@beneficiario/PATCH_DOCUMENTO_CONFERENCIA_SUCCESS',
  PATCH_DOCUMENTO_CONFERENCIA_ERROR:
    '@beneficiario/PATCH_DOCUMENTO_CONFERENCIA_ERROR',
  PATCH_DOCUMENTO_CONFERENCIA_RENEW:
    '@beneficiario/PATCH_DOCUMENTO_CONFERENCIA_RENEW',
};

const INITIAL_STATE = {
  getDocumentosStatus: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  getBeneficiariesNestle: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  getDocumentoDetalhe: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  patchDocumentoConferencia: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
};

export default function beneficiario(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.POST_DATA_BENEFICIARIES_NESTLE_REQUEST: {
        draft.getBeneficiariesNestle.loading = true;
        break;
      }
      case Types.POST_DATA_BENEFICIARIES_NESTLE_SUCCESS: {
        draft.getBeneficiariesNestle.loading = false;
        draft.getBeneficiariesNestle.response = action.payload.response;
        draft.getBeneficiariesNestle.success = action.payload.success;
        break;
      }
      case Types.POST_DATA_BENEFICIARIES_NESTLE_ERROR: {
        draft.getBeneficiariesNestle.loading = false;
        draft.getBeneficiariesNestle.isError = true;
        draft.getBeneficiariesNestle.error = action.payload.error;
        break;
      }
      case Types.GET_DOCUMENTOS_STATUS_REQUEST: {
        draft.getDocumentosStatus.loading = true;
        break;
      }
      case Types.GET_DOCUMENTOS_STATUS_SUCCESS: {
        draft.getDocumentosStatus.loading = false;
        draft.getDocumentosStatus.response = action.payload.response;
        draft.getDocumentosStatus.success = action.payload.success;
        break;
      }
      case Types.GET_DOCUMENTOS_STATUS_ERROR: {
        draft.getDocumentosStatus.loading = false;
        draft.getDocumentosStatus.isError = true;
        draft.getDocumentosStatus.error = action.payload.error;
        break;
      }
      case Types.GET_DOCUMENTO_DETALHE_REQUEST: {
        draft.getDocumentoDetalhe.loading = true;
        break;
      }
      case Types.GET_DOCUMENTO_DETALHE_SUCCESS: {
        draft.getDocumentoDetalhe.loading = false;
        draft.getDocumentoDetalhe.response = action.payload.response;
        draft.getDocumentoDetalhe.success = action.payload.success;
        break;
      }
      case Types.GET_DOCUMENTO_DETALHE_ERROR: {
        draft.getDocumentoDetalhe.loading = false;
        draft.getDocumentoDetalhe.isError = true;
        draft.getDocumentoDetalhe.error = action.payload.error;
        break;
      }
      case Types.GET_DOCUMENTO_DETALHE_RENEW: {
        draft.getDocumentoDetalhe.loading = false;
        draft.getDocumentoDetalhe.success = false;
        draft.getDocumentoDetalhe.response = {};
        draft.getDocumentoDetalhe.unsuccessResponse = [];
        draft.getDocumentoDetalhe.error = null;
        draft.getDocumentoDetalhe.isError = false;
        break;
      }
      case Types.PATCH_DOCUMENTO_CONFERENCIA_REQUEST: {
        draft.patchDocumentoConferencia.success = false;
        draft.patchDocumentoConferencia.unsuccessResponse = [];
        draft.patchDocumentoConferencia.loading = false;
        draft.patchDocumentoConferencia.isError = false;
        draft.patchDocumentoConferencia.error = [];
        break;
      }
      case Types.PATCH_DOCUMENTO_CONFERENCIA_SUCCESS: {
        draft.patchDocumentoConferencia.success = action.payload.isSuccess;
        draft.patchDocumentoConferencia.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_DOCUMENTO_CONFERENCIA_ERROR: {
        draft.patchDocumentoConferencia.error = action.payload.error;
        draft.patchDocumentoConferencia.isError = true;
        draft.patchDocumentoConferencia.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_DOCUMENTO_CONFERENCIA_RENEW: {
        draft.patchDocumentoConferencia.success = false;
        draft.patchDocumentoConferencia.unsuccessResponse = [];
        draft.patchDocumentoConferencia.loading = false;
        draft.patchDocumentoConferencia.isError = false;
        draft.patchDocumentoConferencia.error = [];
        break;
      }
      default:
    }
  });
}

export const Creators = {
  postDataBeneficiariesNestleRequest: (params) => ({
    type: Types.POST_DATA_BENEFICIARIES_NESTLE_REQUEST,
    payload: { params },
  }),
  postDataBeneficiariesNestleSuccess: (response, success) => ({
    type: Types.POST_DATA_BENEFICIARIES_NESTLE_SUCCESS,
    payload: { response, success },
  }),
  postDataBeneficiariesNestleError: (error) => ({
    type: Types.POST_DATA_BENEFICIARIES_NESTLE_ERROR,
    payload: { error },
  }),
  getDocumentosStatusRequest: (params) => ({
    type: Types.GET_DOCUMENTOS_STATUS_REQUEST,
    payload: { params },
  }),
  getDocumentosStatusSuccess: (response, success) => ({
    type: Types.GET_DOCUMENTOS_STATUS_SUCCESS,
    payload: { response, success },
  }),
  getDocumentosStatusError: (error) => ({
    type: Types.GET_DOCUMENTOS_STATUS_ERROR,
    payload: { error },
  }),
  getDocumentoDetalheRequest: (params, idBeneficiario) => ({
    type: Types.GET_DOCUMENTO_DETALHE_REQUEST,
    payload: { params, idBeneficiario },
  }),
  getDocumentoDetalheSuccess: (response, success) => ({
    type: Types.GET_DOCUMENTO_DETALHE_SUCCESS,
    payload: { response, success },
  }),
  getDocumentoDetalheError: (error) => ({
    type: Types.GET_DOCUMENTO_DETALHE_ERROR,
    payload: { error },
  }),
  getDocumentoDetalheRenew: () => ({
    type: Types.GET_DOCUMENTO_DETALHE_RENEW,
    payload: {},
  }),
  patchDocumentoConferenciaRequest: (params) => ({
    type: Types.PATCH_DOCUMENTO_CONFERENCIA_REQUEST,
    payload: { params },
  }),
  patchDocumentoConferenciaSuccess: (unsuccessResponse, isSuccess) => ({
    type: Types.PATCH_DOCUMENTO_CONFERENCIA_SUCCESS,
    payload: { unsuccessResponse, isSuccess },
  }),
  patchDocumentoConferenciaError: (error) => ({
    type: Types.PATCH_DOCUMENTO_CONFERENCIA_ERROR,
    payload: { error },
  }),
  patchDocumentoConferenciaRenew: () => ({
    type: Types.PATCH_DOCUMENTO_CONFERENCIA_RENEW,
  }),
};
